export const iconFontAwesomeCodingQrcode = (
	<i className="fa-solid fa-qrcode"></i>
);
